'use client';

import React from 'react';
import Link from 'next/link';
import { HiOutlineHome } from '@react-icons/all-files/hi/HiOutlineHome';
import { HiOutlineOfficeBuilding } from '@react-icons/all-files/hi/HiOutlineOfficeBuilding';
import { HiOutlineScale } from '@react-icons/all-files/hi/HiOutlineScale';
import { HiOutlineCash } from '@react-icons/all-files/hi/HiOutlineCash';
import { HiOutlineShieldCheck } from '@react-icons/all-files/hi/HiOutlineShieldCheck';
import { HiOutlineHeart } from '@react-icons/all-files/hi/HiOutlineHeart';
import { HiOutlineLightningBolt } from '@react-icons/all-files/hi/HiOutlineLightningBolt';
import { HiOutlineDesktopComputer } from '@react-icons/all-files/hi/HiOutlineDesktopComputer';
import { HiOutlineShoppingCart } from '@react-icons/all-files/hi/HiOutlineShoppingCart';
import { HiOutlineBookOpen } from '@react-icons/all-files/hi/HiOutlineBookOpen';
import { IVertical } from './verticalData';
import {
  StyledHero,
  StyledStatBar,
  StyledGrid,
  StyledGridInner,
  StyledCardsGrid,
  StyledVerticalCard,
  StyledCardCta,
  StyledBottomCta,
} from './IndustriesHub.styles';

const VERTICAL_ICONS: Record<string, React.ReactNode> = {
  'home-services': <HiOutlineHome />,
  'real-estate': <HiOutlineOfficeBuilding />,
  'legal': <HiOutlineScale />,
  'financial-services': <HiOutlineCash />,
  'insurance': <HiOutlineShieldCheck />,
  'healthcare': <HiOutlineHeart />,
  'fitness': <HiOutlineLightningBolt />,
  'saas': <HiOutlineDesktopComputer />,
  'ecommerce': <HiOutlineShoppingCart />,
  'education': <HiOutlineBookOpen />,
};

interface IProps {
  verticals: IVertical[];
}

export const IndustriesHub = ({ verticals }: IProps) => {
  return (
    <>
      <StyledHero>
        <h1>Interactive Widgets for Every Industry</h1>
        <p>
          Common Ninja helps businesses in every vertical convert more visitors
          with interactive calculators, quizzes, and engagement tools. No coding
          required.
        </p>
        <StyledStatBar>
          <span>500K+ Businesses</span>
          <span>200+ Widgets</span>
          <span>200+ Platforms</span>
          <span>No Coding Required</span>
        </StyledStatBar>
      </StyledHero>

      <StyledGrid>
        <StyledGridInner>
          <StyledCardsGrid>
            {verticals.map((v) => (
              <StyledVerticalCard key={v.slug}>
                <span className="card-icon">
                  {VERTICAL_ICONS[v.slug]}
                </span>
                <h2>{v.name}</h2>
                <span className="subtypes">{v.subtypes}</span>
                <p className="tagline">{v.tagline}</p>
                <StyledCardCta as={Link} href={`/industries/${v.slug}`}>
                  Explore Widgets
                </StyledCardCta>
              </StyledVerticalCard>
            ))}
          </StyledCardsGrid>
        </StyledGridInner>
      </StyledGrid>

      <StyledBottomCta>
        <h2>Don&apos;t see your industry?</h2>
        <p>
          Common Ninja&apos;s 200+ widgets work for any business. Browse the
          full library to find the right tools for your website.
        </p>
        <Link href="/widgets">Browse All Widgets</Link>
      </StyledBottomCta>
    </>
  );
};
